import {
  QuestionIds,
  questionPresentationContent
} from "../../data/QuestionPresentation";

export const getPhotosQuantity = (questionsArray, questionId, answerId) =>
  questionsArray
    .find((question) => question.id === questionId)
    .answers.find((answer) => answer.id === answerId).imageQuantityRequired;

export const getHaveAnswersChanged = (originalValues, changedValues) => {
  const answersNotChanged = changedValues.some((value) =>
    originalValues.includes(value)
  );
  return !answersNotChanged;
};

export const renderCorrectLabel = (question, answer) => {
  if (question.id === QuestionIds.EXTERIORBODYWORK) {
    if (answer.id === 34) {
      return answer.label;
    } else {
      return `There are imperfections on the exterior bodywork - ${answer.label}`;
    }
  } else {
    return answer.label;
  }
};
